import { render, staticRenderFns } from "./CreateCustomers.vue?vue&type=template&id=7c6fea41&"
import script from "./CreateCustomers.vue?vue&type=script&lang=js&"
export * from "./CreateCustomers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports